module.exports = __webpack_public_path__ + "img/uk-events-3.8d94e602.png";